<div class="verification-container">
    <div class="">
        <!-- Logo de Phoenix -->
        <!-- <div class="logo-container">
            <img src="/assets/img/phoenix-logo.png" alt="Phoenix - Enhancing Silver Value" class="phoenix-logo" />
        </div> -->
        
        <!-- <h2 class="verification-title">Verificación de correo electrónico</h2> -->
        <p class="verification-subtitle">Verificación de correo electrónico</p>
        
        <div class="email-notification">
            <p>Enviamos un correo electrónico a <strong>{{authUser?.email}}</strong> ¿No es tu correo electrónico? <a
                    (click)="navigateToRegister()">Editar aquí</a></p>
        </div>

        <div *ngIf="validationError.length>0" class="alert alert-danger">
            {{validationError}}
        </div>

        <form #codeForm="ngForm">
            <div class="code-inputs">
                <input type="number" name="code1" placeholder="-" class="code-input" [(ngModel)]="model.code1"
                    (input)="moveToNext($event, 1)" (keydown)="validateKey($event)" (paste)="handlePaste($event, 1)"
                    #codeInput required autocomplete="off" />
                <input type="number" name="code2" placeholder="-" class="code-input" [(ngModel)]="model.code2"
                    (input)="moveToNext($event, 2)" (keydown)="validateKey($event)" (paste)="handlePaste($event, 2)"
                    #codeInput required autocomplete="off" />
                <input type="number" name="code3" placeholder="-" class="code-input" [(ngModel)]="model.code3"
                    (input)="moveToNext($event, 3)" (keydown)="validateKey($event)" (paste)="handlePaste($event, 3)"
                    #codeInput required autocomplete="off" />
                <input type="number" name="code4" placeholder="-" class="code-input" [(ngModel)]="model.code4"
                    (input)="moveToNext($event, 4)" (keydown)="validateKey($event)" (paste)="handlePaste($event, 4)"
                    #codeInput required autocomplete="off" />
                <input type="number" name="code5" placeholder="-" class="code-input" [(ngModel)]="model.code5"
                    (input)="moveToNext($event, 5)" (keydown)="validateKey($event)" (paste)="handlePaste($event, 5)"
                    #codeInput required autocomplete="off" />
            </div>

            <button [disabled]="!validationOk" class="boton-principal" type="button" (click)="next()">Continuar</button>

        </form>

        <div *ngIf="activeTimer" class="timer">
            Tiempo de espera: <span>{{ timer }}</span>
        </div>
        <div *ngIf="showSendVerification" class="timer">
            ¿No recibiste el código de verificación?: <a href="javascript:void(0)" (click)="resend()"> Reenviar
                aquí</a>
        </div>
    </div>
</div>